import useReviewsStore from '~/modules/reviews/stores/useReviewsStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

const useReviews = () => passStoreThroughComposableFactory(useReviewsStore());

export default useReviews;
